/*
 *  Number Countdown
 *    Scripts for the number countdown
 *
 *  Version:
 *    1.0.0
 */

const SELECTOR_CONTAINER = '[data-number-countdown]';

document
  .querySelectorAll<HTMLSpanElement>(SELECTOR_CONTAINER)
  .forEach((container) => {
    let total = parseInt(container.getAttribute('data-number-countdown-total'));
    const destination = parseInt(container.getAttribute('data-number-countdown-destination'));
    const downloadTimer = setInterval(() => {
      if (total <= destination) {
        clearInterval(downloadTimer);
      } else {
        container.innerHTML = total.toString();
      }
      total -= 1;
    }, 50);
  });
